'use strict';
var RoutePath = require('./constants/routePath');

exports.getLoginUrl = () => `/${RoutePath.ROUTE_LOGIN}`;
exports.getLogoutUrl = () => `/${RoutePath.ROUTE_LOGOUT}`;
exports.getSecurityUrl = () => `/${RoutePath.ROUTE_SECURITY}`;
exports.getNoAvailableModule = () => `/${RoutePath.ROUTE_ERROR}/${RoutePath.ROUTE_NO_AVAILABLE_MODULES}`;
exports.getAccessDenied = () => `/${RoutePath.ROUTE_ERROR}/${RoutePath.ROUTE_ACCESS_DENIED}`;
exports.getSystemError = () => `/${RoutePath.ROUTE_SYSTEM_ERROR}`;
